import type { AxiosResponse } from 'axios';
import { String } from '../Strings/String';
import { AxiosMutator } from './Mutators/AxiosMutator';
import type { ErrorData, ErrorProviderError, GenericError, IErrorMutator } from './types';

export class ErrorProvider<TResponse = AxiosResponse<ErrorData>> {
  private error: ErrorProviderError;

  constructor(private customMutator: IErrorMutator = new AxiosMutator()) {}

  private isUserError(): boolean {
    return this.error?.name === 'UserError';
  }

  public parse(error: GenericError): Exclude<ErrorProvider<TResponse>, 'parse'> {
    this.error = this.customMutator.parse(error);
    return this;
  }

  public async parseAsync(error: GenericError): Promise<Exclude<ErrorProvider<TResponse>, 'parse'>> {
    this.error = await this.customMutator.parseAsync(error);
    return this;
  }

  public getStatus(): number {
    return this.error?.status || this.error?.code;
  }

  public getFieldEmpty(): string {
    if (this.error?.data?.field) {
      return this.error?.data?.field;
    }

    if (this.isUserError() && this.error.field) {
      return this.error.field;
    }

    return String.Empty;
  }

  public getMessageOrEmpty(): string {
    if (this.error?.data?.message) {
      return this.error?.data?.message;
    }

    if (this.isUserError() && this.error.message) {
      return this.error.message;
    }
    return String.Empty;
  }

  public getMessageOrDefault(): string {
    return this.error?.data?.message || 'An error occurred';
  }

  public getResponse(): ErrorProviderError {
    return this.error;
  }
}
